import React from 'react'

const HVAC = () => {
    return (
        <div>
            <section class="inner-banner">
                <div class="thm-container">
                    <h2> Product Details </h2>
                    <div class="breadcumb">
                        <a href="/">Automation Solution</a>
                        <i class="fa fa-angle-right"></i>
                        <span>Building Solution</span>
                        <i class="fa fa-angle-right"></i>
                        <span>HVAC Control Systems</span>
                    </div>
                </div>
            </section>
            <div className='container py-4'>
                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img src='/img/hvac.jpg' width={400}></img>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h2 style={{ textDecoration: "underline" }}>HVAC Control Systems:</h2>
                        <p className="mbot25">
                            Our HVAC control systems ensure optimal climate conditions in your buildings. We provide solutions that integrate with building automation systems for efficient management of heating, ventilation, and air conditioning.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HVAC
